import { TechniquesFilters } from "domain/entities/techniques.entities";
import {
  DurationFilter,
  ActivitiesPageFilters,
} from "domain/entities/activities.entities";

export const getActivitiesFilters = (
  filters: TechniquesFilters &
    Partial<ActivitiesPageFilters> &
    Partial<{ duration: DurationFilter; search: string }>
) => {
  // const participants = getParticipants(filters.participants);
  const duration = getDuration(filters.selectedDuration);

  return {
    "context[$in]": filters.contexts,
    "type[$in]": filters.types,
    ...(filters.modalities?.includes("remote") && { remote: true }),
    ...(filters.modalities?.includes("onsite") && { onsite: true }),
    ...(filters.duration && { duration: filters.duration }),
    ...(filters.selectedDuration?.length > 0 && duration),
    ...(filters["$sort[createdAt]"] && {
      "$sort[createdAt]": filters["$sort[createdAt]"] || -1,
    }),
    ...(filters["$sort[duration]"] && {
      "$sort[duration]": filters["$sort[duration]"] || -1,
    }),
    ...(filters.participants && {
      "participantsMin[$lte]": filters.participants,
      "participantsMax[$gte]": filters.participants,
    }),
    ...(typeof filters.isInniz === "boolean" && { isInniz: filters.isInniz }),
    ...(filters.pauses === false && { "type[$nin]": ["pause"] }),
    ...(filters.search?.length > 0 && {
      "title[$ilike]": `%${filters.search}%`,
    }),
    "intentsRef.intent[$in]": filters.techObjectives || filters.seanceObjectives,
    // "techniqueIntentsRef.intent[$in]": filters.seanceObjectives,
    "objectifsRef.objectif[$in]": filters.supportObjectives,
    "series[$in]": filters.categories,
    ...((filters.$limit || filters.$limit === 0) && { $limit: filters.$limit }),
    ...(filters.premium !== undefined && { premium: filters.premium }),
    ...(filters.level && { "level[$in]": filters.level }),
  };
};

const getDuration = (duration: string) => {
  if (duration) {
    if (duration === "lte120") {
      return { "duration[$lte]": 120 };
    } else if (duration === "lte240") {
      return { "duration[$gte]": 120, "duration[$lte]": 240 };
    } else if (duration === "lte1440") {
      return { "duration[$gte]": 240, "duration[$lte]": 1440 };
    } else if (duration === "gte1440") {
      return { "duration[$gte]": 1440 };
    }
  } else return null;
};
